import { IMAGES } from "./images";

export const MARKETS = [
  {
    id: "weddings",
    nameEn: "Destination Weddings",
    nameRu: "Свадьбы за рубежом",
    image: IMAGES.weddings,
    descriptionEn:
      "Monumental installations, arches and imperial tables for unforgettable celebrations across the globe.",
    descriptionRu:
      "Монументальные инсталляции, арки и торжественные столы для незабываемых праздников по всему миру.",
  },
  {
    id: "hospitality",
    nameEn: "Luxury Hospitality",
    nameRu: "Премиальное гостеприимство",
    image: IMAGES.hospitality,
    descriptionEn:
      "Lobbies, suites and restaurants where fresh flowers set the tone for a premium guest experience.",
    descriptionRu:
      "Лобби, номера и рестораны, где свежие цветы формируют атмосферу премиального сервиса.",
  },
  {
    id: "editorial",
    nameEn: "Editorial & Fashion",
    nameRu: "Съёмки и мода",
    image: IMAGES.editorial,
    descriptionEn:
      "Statement blooms for photo productions, runway and campaigns that demand a distinctive palette.",
    descriptionRu:
      "Выразительные цветы для фотосъёмок, подиумов и кампаний, которым нужна особенная палитра.",
  },
  {
    id: "corporate",
    nameEn: "Corporate & Seasonal Events",
    nameRu: "Корпоративные и сезонные события",
    image: IMAGES.corporate,
    descriptionEn:
      "Galas, launches and seasonal programs delivered with consistency and scale, wherever you operate.",
    descriptionRu:
      "Гала-вечера, презентации и сезонные программы со стабильными поставками в любом масштабе.",
  },
  {
    id: "retail",
    nameEn: "Floral Retail",
    nameRu: "Цветочная розница",
    image: IMAGES.retail,
    descriptionEn:
      "Reliable, high-volume supply for boutiques and retailers building a premium floral offering.",
    descriptionRu:
      "Надёжные крупные поставки для бутиков и ритейлеров, развивающих премиальный цветочный ассортимент.",
  },
];
